module.exports = __webpack_public_path__ + "static/media/NO.c3e14635.png";